/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  Expression,
  List,
  SiteMcpServer,
  SiteMcpServerHeaders,
  SiteMcpServerName,
  SiteMcpServerTransport,
  URL,
} from "./data-contracts";

/**
 * @description Returns a paginated list of Model Context Protocol (MCP) server configurations attached to the site. MCP servers expose tools and resources that the AI Assistant can call when helping site visitors find information. Use this to audit or manage the AI tool integrations available on a site.
 * @tags site-mcp-servers
 * @name ListSiteMcpServers
 * @summary List all MCP servers configured for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/mcp-servers
 * @secure
 */

// @ts-ignore
export const listSiteMcpServers: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteMcpServer[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers",
  method: "get",
  streaming: false,
  tags: ["site-mcp-servers"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Registers a new Model Context Protocol (MCP) server with the site, providing its URL, transport type, request headers, and an optional conditional expression to control visibility per visitor. Once added, the MCP server's tools become available to the AI Assistant when helping visitors of this site.
 * @tags site-mcp-servers
 * @name CreateSiteMcpServer
 * @summary Add a new MCP server configuration to a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/mcp-servers
 * @secure
 */

// @ts-ignore
export const createSiteMcpServer: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the MCP server */
    name: SiteMcpServerName;
    url: URL;
    /** Transport protocol used to connect to the MCP server */
    transport?: SiteMcpServerTransport;
    /** HTTP headers sent with requests to this server */
    headers: SiteMcpServerHeaders;
    /** Conditional expression used to evaluate whether the MCP server should be available to the site's visitor (should evaluate to a boolean). If set to null, the condition will be removed. */
    condition?: Expression | null;
  };
  RequestHeaders: {};
  ResponseBody: SiteMcpServer;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers",
  method: "post",
  streaming: false,
  tags: ["site-mcp-servers"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Attempts to connect to a Model Context Protocol (MCP) server using the provided URL, transport, and headers, then lists the tools it exposes. Use this to validate an MCP server's configuration before saving it to a site. The configuration is not persisted. A connection failure is reported in the response body with `success` set to `false` rather than as an HTTP error.
 * @tags site-mcp-servers, internal
 * @name TestSiteMcpServer
 * @summary Test a connection to an MCP server configuration
 * @request POST:/orgs/{organizationId}/sites/{siteId}/mcp-servers/test
 * @secure
 */

// @ts-ignore
export const testSiteMcpServer: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    url: URL;
    /** Transport protocol used to connect to the MCP server */
    transport?: SiteMcpServerTransport;
    /** HTTP headers sent with requests to this server */
    headers?: SiteMcpServerHeaders;
  };
  RequestHeaders: {};
  ResponseBody: {
    object: "site-mcp-server-test-result";
    /** Whether GitBook could connect to the MCP server. */
    success: boolean;
    /** Tools exposed by the MCP server, when the connection succeeded. */
    tools?: {
      name: string;
      description?: string;
    }[];
    /** A human-readable reason for the failure, when the connection failed. */
    error?: string;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/test",
  method: "post",
  streaming: false,
  tags: ["site-mcp-servers", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves the configuration of a specific MCP server registered with the site. Use this to inspect an MCP server's details before updating or removing it.
 * @tags site-mcp-servers
 * @name GetSiteMcpServerById
 * @summary Get an MCP server configuration for a site by its ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
 * @secure
 */

// @ts-ignore
export const getSiteMcpServerById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the MCP server */
    siteMcpServerId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteMcpServer;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
  method: "get",
  streaming: false,
  tags: ["site-mcp-servers"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Modifies an existing MCP server's configuration. Only provided fields are updated; omitting a field leaves it unchanged. Set condition to null to remove it and make the MCP server available to all visitors.
 * @tags site-mcp-servers
 * @name UpdateSiteMcpServerById
 * @summary Update an MCP server configuration for a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
 * @secure
 */

// @ts-ignore
export const updateSiteMcpServerById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the MCP server */
    siteMcpServerId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the MCP server */
    name?: SiteMcpServerName;
    /**
     * @format uri
     * @maxLength 2048
     */
    url?: string;
    /** Transport protocol used to connect to the MCP server */
    transport?: SiteMcpServerTransport;
    /** HTTP headers sent with requests to this server */
    headers?: SiteMcpServerHeaders;
    /** Conditional expression used to evaluate whether the MCP server should be available to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
    condition?: Expression | null;
  };
  RequestHeaders: {};
  ResponseBody: SiteMcpServer;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
  method: "patch",
  streaming: false,
  tags: ["site-mcp-servers"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-mcp-servers
 * @name DeleteSiteMcpServerById
 * @summary Delete a site MCP server
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}
 * @secure
 */

// @ts-ignore
export const deleteSiteMcpServerById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the MCP server */
    siteMcpServerId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/mcp-servers/{siteMcpServerId}",
  method: "delete",
  streaming: false,
  tags: ["site-mcp-servers"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
